import React from "react";
import classNames from "classnames";
import { Button, Text } from "@jsq/ds/core";
import { EM_DASH } from "./constants";
import * as styles from "./styles_vanilla.css";

export type DocumentData = {
  id: number;
  name: string;
  s3Link: string;
  documentPurpose?: {
    baseType?: string | null;
    expires?: boolean | null;
    complianceObjectType?: string | null;
  } | null;
  status?: string | null;
  metadata?: Array<{ key: string; value?: string | null }> | null;
  hasMetaDataChange?: boolean;
};

export type ValueCellProps = {
  value: string | number | undefined;
  docs: DocumentData[] | undefined;
  isDocument: boolean | undefined;
  onDocumentClick?: (docId: number) => void;
  dimmed?: boolean;
};

export const ValueCell = ({
  value,
  docs,
  isDocument,
  onDocumentClick,
  dimmed = false,
}: ValueCellProps): React.ReactNode => {
  if (isDocument && docs && docs.length > 0) {
    return (
      <div className={styles.documentList}>
        {docs.map((doc) => (
          <Button
            key={doc.id}
            variant="link"
            displayAsLink
            className={classNames(styles.documentLink, dimmed && styles.dimmedText)}
            onClick={() => onDocumentClick?.(doc.id ?? 0)}
          >
            {doc.hasMetaDataChange ? `${doc.name.trimEnd()} *` : doc.name}
          </Button>
        ))}
      </div>
    );
  }

  const stringValue = String(value ?? "");
  if (!stringValue || stringValue === EM_DASH) {
    return (
      <Text
        variant="regular-md"
        className={classNames(styles.emptyValue, dimmed && styles.dimmedText)}
      >
        {EM_DASH}
      </Text>
    );
  }

  return (
    <Text variant="regular-md" className={dimmed ? styles.dimmedText : undefined}>
      {stringValue}
    </Text>
  );
};
